<template>
  <main-layout>
    <template #nav>
      <div class="flex justify-between items-center">
        <router-link
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
          :to="{
            name: 'Basket',
            query: {
              token: Jwt,
            },
          }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </router-link>
        <h1 class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">Confirm</h1>
        <router-link
          :to="{
            name: 'Basket',
            query: {
              token: Jwt,
            },
          }"
          class="relative inline-flex items-center p-1.5 text-sm font-medium text-center rounded-full border-2 border-secondary-600 focus:ring-0 focus:outline-none focus:ring-primary-600"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-secondary-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 11 4-7" /><path d="m19 11-4-7" /><path d="M2 11h20" /><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8c.9 0 1.8-.7 2-1.6l1.7-7.4" /><path d="m9 11 1 9" /><path d="M4.5 15.5h15" /><path d="m15 11-1 9" /></svg>
          <span class="sr-only">Total basket items</span>
          <div class="absolute inline-flex items-center justify-center h-4 w-4 font-bold text-primary-600 bg-secondary-600 rounded-md -top-1 -right-2" style="font-size: 8px;">{{ TotalBasketItems }}</div>
        </router-link>
      </div>
    </template>
    <form @submit.prevent class="p-4">
      <div class="mb-4">
        <label
          class="block mb-2 text-sm font-medium text-gray-900"
          for="delivery-method"
        >
          Delivery method
        </label>
        <select
          class="bg-gray-50 border-2 border-secondary-600 text-gray-900 text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-600 block w-full p-2.5"
          id="delivery-method"
          required
          placeholder=""
          v-model="deliveryMethod"
        >
          <option
            selected
            :value="null"
            disabled
          >Choose a delivery method</option>
          <option
            :key="m.method"
            v-for="m in DeliveryMethods"
            :value="m.value"
          >
            {{ m.label }}
          </option>
        </select>
        <div
          class="text-xs text-red-600"
          v-if="noDeliveryMethodSelected"
        >
          Please select delivery method
        </div>

      </div>
      <div class="mb-4" v-if="PaymentMethods.length">
        <label
          class="block mb-2 text-sm font-medium text-secondary-600"
          for="payment-method"
        >
          Payment method
        </label>
        <select
          class="bg-gray-50 border-2 border-secondary-600 text-secondary-600 text-sm rounded-lg focus:ring-secondary-600 focus:border-secondary-600 block w-full p-2.5"
          id="payment-method"
          required
          placeholder=""
          v-model="paymentMethod"
        >
          <option
            selected
            :value="null"
            disabled
          >Choose a payment method</option>
          <option
            :key="m.method"
            v-for="m in PaymentMethods"
            :value="m.value"
          >
            {{ m.label }}
          </option>
        </select>
        <div
          class="text-xs text-red-600"
          v-if="noPaymentMethodSelected"
        >
          Please select payment method
        </div>

      </div>
      <button
        class="text-secondary-600 bg-primary-600 w-full hover:bg-primary-500 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none disabled:bg-disabled-300 disabled:shadow-none disabled:ring-0 disabled:cursor-not-allowed disabled:bg-primary-500"
        :disabled="isSubmittingOrder"
        type="submit"
        @click="placeOrder"
      >
        <span v-if="isSubmittingOrder">
          <svg
            aria-hidden="true"
            role="status"
            class="inline w-4 h-4 mr-3 text-white animate-spin"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="#E5E7EB" />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentColor" />
          </svg>
        </span>
        Place Order
      </button>
    </form>
  </main-layout>
</template>
<script setup>

// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import { useRouter } from 'vue-router';

import { notify } from 'notiwind';
import { computed, ref, watch } from 'vue';
import { useBasketStore } from '@/stores/basket';
import { useAccountStore } from '@/stores/account';

import MainLayout from '@/layouts/MainLayout.vue';

const BasketItems = computed(() => useBasketStore().Data);
const IsLoadingBasketItems = computed(() => useBasketStore().IsLoading);
const DeliveryMethods = computed(() => useAccountStore().DeliveryMethods);
const PaymentMethods = computed(() => useAccountStore().PaymentMethods);

const router = useRouter();
const isSubmittingOrder = ref(false);
const Jwt = computed(() => useAccountStore().Jwt);

const deliveryMethod = ref(null);
const paymentMethod = ref(null);
const noDeliveryMethodSelected = ref(false);
const noPaymentMethodSelected = ref(false);
const TotalBasketItems = computed(() => useBasketStore().TotalItems);

const {
  Load: LoadBasket,
} = useBasketStore();

const placeOrder = async () => {
  noDeliveryMethodSelected.value = !deliveryMethod.value;
  noPaymentMethodSelected.value = !paymentMethod.value;
  if (noDeliveryMethodSelected.value) return;
  if (PaymentMethods.value?.length) {
    if (noPaymentMethodSelected.value) {
      return;
    }
  }
  isSubmittingOrder.value = true;
  try {
    const basketItemIds = (BasketItems.value ?? []).map((item) => item.id);
    await axios({
      data: {
        basketItemIds,
        deliveryMethod: deliveryMethod.value,
        paymentMethod: paymentMethod.value,
      },
      method: 'POST',
      url: `${import.meta.env.VITE_APP_NEXT_API_URL}/v1/orders`,
    });
    LoadBasket({});
    router.replace({
      name: 'OrderPlaced',
      query: {
        token: Jwt.value,
      },
    });
  } catch (error) {
    let message;
    if (error.response) {
      message = error.response.data.message;
    }
    message = message ?? 'An error occured while placing order';
    notify(
      {
        variant: 'bg-red-700',
        group: 'foo',
        text: message,
      },
      5000,
    );
  } finally {
    isSubmittingOrder.value = false;
  }
};

watch(BasketItems, (newV) => {
  if (!newV?.length && IsLoadingBasketItems.value) {
    router.replace({
      name: 'Basket',
      query: {
        token: Jwt.value,
      },
    });
  }
}, {
  immediate: true,
});

watch(deliveryMethod, (newV) => {
  if (newV) {
    noDeliveryMethodSelected.value = false;
  }
});

watch(paymentMethod, (newV) => {
  if (newV) {
    noPaymentMethodSelected.value = false;
  }
});
</script>
